import { useState } from 'react';

import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { Merchant } from 'types/embedded/merchant';

import { CreatedSuccessDialog } from './components/CreatedSuccessDialog/CreatedSuccessDialog';
import { MerchantsCreateForm } from './MerchantsCreateForm';

export const MerchantsCreate: React.FC = () => {
  const [createdMerchant, setCreatedMerchant] = useState<Merchant | null>(null);

  return (
    <CreateGuesserPage
      listName="Мерчанты"
      mutationOptions={{
        onError: () => undefined,
        onSuccess: (merchant: Merchant) => setCreatedMerchant(merchant),
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" />,
      ]}
      title="Создание мерчанта"
    >
      <MerchantsCreateForm />
      {createdMerchant && <CreatedSuccessDialog merchant={createdMerchant} />}
    </CreateGuesserPage>
  );
};
